/**
 * @description Generic composable for handling alert for GAlert
 */
export function useGenericAlert() {
  const isAlertVisible = ref<boolean>(false)
  const alertContent = ref<{
    header: string
    subHeader?: string
    message: string
  }>({
    header: 'Oops.\nUnexpected error',
    message: 'Something went wrong. Please try again.'
  })

  function onAlertDismiss() {
    isAlertVisible.value = false
  }

  return {
    alertContent,
    isAlertVisible,
    onAlertDismiss
  }
}
